export const environment = {
  production: true,
  apiBaseUrl: 'https://testoffice-stage.spirit-indianer.com',
  jiraBrowseBase: 'https://spirittesting.atlassian.net/browse/',
  swaggerUrl: 'https://testoffice-stage.spirit-indianer.com/swagger-ui.html',
  patQuickstartUrl: 'https://github.com/SpiritTesting/testOFFICE-ng-agentic/blob/master/docs/api-pat-guide.md',
  supportEmail: 'it-support@spirit-testing.com',
};
